import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isBuildACartCreateLinkPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { savePreBuiltCart } from 'swag-client-common/redux/cart/cart.actions';
import { preBuiltCartUserEmailSelector } from 'swag-client-common/redux/user/user.selectors';
import { preBuiltCartLinkSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { addNotification } from 'swag-client-common/redux/snackbar/snackbar.actions';
import { INotificationType } from 'swag-common/interfaces/snackbar-notification-type.interface';
import { BuildACartCreateLinkPopup as BuildACartCreateLinkPopupComponent } from './build-a-cart-create-link-popup';
const mapStateToProps = createStructuredSelector({
  open: isBuildACartCreateLinkPopupShownSelector,
  email: preBuiltCartUserEmailSelector,
  cartLink: preBuiltCartLinkSelector
});
const mapDispatchToProps = dispatch => ({
  onContinue: () => {
    dispatch(hidePopup());
  },
  onDone: () => savePreBuiltCart(),
  onCopy: () => {
    dispatch(addNotification({
      message: 'Copied!',
      type: INotificationType.SUCCESS,
      key: Date.now()
    }));
  }
});
export const BuildACartCreateLinkPopup = connect(mapStateToProps, mapDispatchToProps)(BuildACartCreateLinkPopupComponent);